import type { StytchB2BClient } from '@stytch/react/b2b';

export async function hydrateStytchSession(
  stytch: StytchB2BClient,
  tokens: { session_token: string; session_jwt: string },
): Promise<void> {
  if (!tokens.session_token || !tokens.session_jwt) {
    throw new Error('hydrateStytchSession requires both session_token and session_jwt');
  }
  stytch.session.updateSession({
    session_token: tokens.session_token,
    session_jwt: tokens.session_jwt,
  });
  await stytch.session.authenticate();
}
